<template src="../../components/shared/contacts/RemoveContactTemplate.html">
</template>

<script>
    import {common} from "../../global/common.js";
    import {api} from "../../global/framework/api.js";

    export default {
        name: "RemoveContactModal",
        data() {
            return {
                fullName: "",
                entityId: 0,
                entityTypeId: 0,
                contactId: 0,
                controllerName: ""
            }
        },
        methods: {
            async showModal({contactId, entityId, entityTypeId}) {
                this.entityId = entityId;
                this.entityTypeId = entityTypeId;
                this.contactId = contactId;
                this.controllerName = entityTypeId == common.ENTITY_TYPE.COMPANY ? "Company" : "ProviderEntity";
                //Load contact Info
                let info = await api.get("Shared", contactId, "GetBasicContactInfo");
                this.fullName = info.firstName + " " + info.lastName;
                this.$refs.modalRef.open();
            },
            async deleteUser() {
                let result = await api.post(this.controllerName, this.entityId + "/removeContact/" + this.contactId, {contactId: this.contactId});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>

</style>